import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaCupons } from "./components/TabelaCupons"

export function CupomEstabelecimentoFornecedor() {
    return (
        <>
            <Cabecalho pagina="Cupons de Desconto" />
            <TabelaCupons />
        </>
    )
}
